// src/components/AnnouncementBar.jsx
import React from "react";
import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import { scrollToSection } from "../utils/scrollToSection";

const AnnouncementBar = () => (
  <AppBar
    position="static"
    elevation={0}
    sx={{ bgcolor: "#0f172a", py: 0.5 }}
  >
    <Toolbar
      disableGutters
      sx={{
        minHeight: 40,
        px: { xs: 2, sm: 4 },
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Typography variant="body2" sx={{ color: "#e5e7eb", textAlign: "center" }}>
        <strong>MVP in progress</strong> · Seeking design partners ·{" "}
        <Box
          component="span"
          sx={{ textDecoration: "underline", cursor: "pointer" }}
          onClick={() => scrollToSection("contact")}
        >
          Get in touch
        </Box>
      </Typography>
    </Toolbar>
  </AppBar>
);

export default AnnouncementBar;
